import React from 'react';
import AddReminderWizard from './components/AddReminderWizard/AddReminderWizard';

export default function AddReminder() {
  return (
    <AddReminderWizard />
  );
}
